import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../../../lib/supabase'
import { reportUnexpectedError } from '../../../../../lib/reportError'

interface ResetCashierPinInput {
  cashierId: string
}

export interface ResetCashierPinResult {
  pin: string
}

async function resetCashierPin(input: ResetCashierPinInput): Promise<ResetCashierPinResult> {
  const { data, error } = await supabase.functions.invoke<ResetCashierPinResult>('reset-cashier-pin', {
    body: { cashierId: input.cashierId },
  })
  if (error) {
    reportUnexpectedError(error)
    throw error
  }
  if (!data) {
    const failure = new Error('No data returned from reset-cashier-pin')
    reportUnexpectedError(failure)
    throw failure
  }
  return data
}

export function useResetCashierPin() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: resetCashierPin,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['cashiers'] }),
  })
}